// VendorQuotationExcelImportCreateScreen.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta } from "hooks";
import { useAddVendorQuotationExcelMutation } from "store/services/vendorQuotationExcelApi";
import VendorQuotationExcelImportForm from "./vendorQuotationExcelComponents/VendorQuotationExcelImportForm";

const VendorQuotationExcelImportCreateScreen = () => {
    const navigate = useNavigate();
    const breadcrumbs = [
        { title: "Vendor Quotation Excels", path: "/app/crm/vendor-quotation-excel/list" },
        { title: "Import Vendor Quotation Excel" },
    ];

    const [addVendorQuotationExcel, { isLoading }] = useAddVendorQuotationExcelMutation();

    const handleCreate = async (data) => {
        try {
            const { _id } = await addVendorQuotationExcel(data).unwrap();
            toast.success("Vendor Quotation Excel successfully created!");
            navigate(`/app/crm/vendor-quotation-excel/${_id}/detail`);
        } catch (err) {
            toast.error(
                err?.data?.message ?? err?.message ?? "Couldn't create Vendor Quotation Excel!",
            );
        }
    };

    useAppMeta("Import Vendor Quotation Excel");

    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
            <BreadcrumbLayout.Paper>
                <VendorQuotationExcelImportForm isBusy={isLoading} onSubmit={handleCreate} />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default VendorQuotationExcelImportCreateScreen;